import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/** TODO:  */
export const onSaveEditsRelay = store.effects.create(
  (feature: Feature) =>
    feature.actions.saveEdits.relay((forward, { chartId: orgChartId }) =>
      feature.selectors
        .getEditingNode({ chartId: orgChartId })
        .asObservable.pipe(
          rxjs.filter(TypeChecker.isNotNullish.raw),
          // TODO: add documentation explaining why take 1
          rxjs.take(1),
          rxjs.map(({ values, modelId }) => {
            if (!values) {
              // TODO: perhaps handle it above in filter case?
              throw new Error('No values on editing node')
            }

            return forward(feature.actions.saveData, {
              input: {
                chartId: orgChartId,
                modelId,
                record: {
                  purposes: [],
                  values,
                },
              },
              output: () => ({
                chartId: orgChartId,
              }),
            })
          }),
        ),
    ).asObservable,
)
